(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var BaseView = require('cf-base-view')
  , googleMapsLoader = require('google-maps')

module.exports = BaseView.extend(
  { initialize: function () {
      this.markers = {}
      googleMapsLoader.load(function (google) {
        this.google = google
        this.render()
        this.trigger('ready')
      }.bind(this))
    }

  , render: function () {
      this.map = new this.google.maps.Map(
          this.el
        , { center: { lat: 51.542733, lng: -0.123471 }
          , zoom: 8
        })
      return this
    }

  // TODO use MarkerWithLabel & SVG icons to get longer labels
  , addMarker: function (label, location, noLabel) {
      // ignore invalid locations
      if (!location || (location && (!location.latitude || !location.longitude))) {
        return
      }

      if (this.markers[label]) this.removeMarker(label)

      var marker = new this.google.maps.Marker(
        { map: this.map
        , label: !noLabel ? label : undefined
        , position: { lat: location.latitude, lng: location.longitude }
        })

      marker.addListener('click', function () {
        this.trigger('marker:click', label)
      }.bind(this))

      this.markers[label] = marker

      this.fitBounds()

      return marker
    }

  , fitBounds: function () {
      var bounds = new this.google.maps.LatLngBounds()

      Object.keys(this.markers).forEach(function (key) {
         bounds.extend(this.markers[key].getPosition())
      }.bind(this))

      this.map.fitBounds(bounds)
      this.map.setCenter(bounds.getCenter())
      if (this.map.getZoom() > 15) this.map.setZoom(15)
    }

  , removeMarker: function (label) {
      if (!this.markers[label]) return
      this.markers[label].setMap(null)
      delete this.markers[label]
      this.fitBounds()
    }

  , clearMarkers: function () {
      Object.keys(this.markers).forEach(function (key) {
        this.markers[key].setMap(null)
      }.bind(this))
      this.markers = {}
    }
  }
)

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/admin/tour/views/tour-map.js","/components/admin/tour/views")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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